import React, { useState, useRef } from "react"

function PlanDescription() {
  const [isEnabled, setIsEnabled] = useState(true)
  const [description, setDescription] = useState("")
  const textareaRef = useRef(null)

  const handleToggle = () => {
    setIsEnabled(!isEnabled)
  }

  const handleSubmit = () => {
    console.log("Submit plan description:", description)
    // Handle submit action
  }

  const handleTextareaChange = (e) => {
    setDescription(e.target.value)
    // Auto-resize textarea
    if (textareaRef.current) {
      textareaRef.current.style.height = "44px"
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`
    }
  }

  return (
    <div id="plan-description-wrapper" className="w-full mb-2">
      <div id="plan-description-container" className="py-4 px-6 bg-white dark:bg-gray-900 border border-gray-200 rounded-md">
        <div id="plan-description-content">
          <div id="plan-description-header" className="mb-4 relative">
            <h2 id="plan-description-title" className="font-semibold text-md text-gray-900 dark:text-gray-100 mb-0">
              Plan Description
            </h2>
            <p id="plan-description-subtitle" className="text-gray-600 dark:text-gray-400 text-sm mt-0">
              Describe here the general plan and guidelines. You don't need to go too much in details.
            </p>
            <div id="plan-description-toggle" className="absolute right-0 top-[-36px]">
              <button
                type="button"
                role="switch"
                aria-checked={isEnabled}
                onClick={handleToggle}
                className={`relative inline-flex items-center h-6 w-11 rounded-full transition-colors duration-150 ${
                  isEnabled ? "bg-blue-600" : "bg-gray-300"
                }`}
              >
                <span
                  className={`inline-block h-5 w-5 transform rounded-full bg-white dark:bg-gray-900 transition-transform duration-150 ${
                    isEnabled ? "translate-x-6" : "translate-x-1"
                  }`}
                  style={{
                    boxShadow: "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(59, 130, 246, 0.5) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px"
                  }}
                ></span>
              </button>
            </div>
          </div>
          <div id="plan-description-form-container" className="relative">
            <form id="plan-description-form" className="flex flex-col">
              <textarea
                id="plan-description-textarea"
                ref={textareaRef}
                name="text"
                placeholder="Write your thoughts here..."
                value={description}
                onChange={handleTextareaChange}
                className="w-full p-3 text-sm text-gray-900 dark:text-gray-100 bg-gray-50 dark:bg-gray-950 dark:bg-gray-950 border border-gray-300 rounded-md resize-none overflow-hidden"
                style={{ minHeight: "44px", height: "44px" }}
              />
              <div id="plan-description-actions" className="flex justify-end mt-1">
                <button
                  id="plan-description-submit-button"
                  type="button"
                  onClick={handleSubmit}
                  className="relative flex items-center justify-between px-5 py-1 bg-gray-600 text-white rounded-md cursor-pointer transition-all duration-300 hover:bg-gray-700"
                >
                  <span
                    className="absolute right-0 w-8 h-32 -mt-12 transition-all duration-500 transform translate-x-12 bg-gray-900 opacity-10 rotate-12 group-hover:-translate-x-40 ease"
                    style={{ transform: "matrix(0.978148, 0.207912, -0.207912, 0.978148, 48, 0)" }}
                  ></span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-5 h-5"
                  >
                    <polygon points="6 3 20 12 6 21 6 3"></polygon>
                  </svg>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PlanDescription

